import React from "react";
import PropTypes from "prop-types";
import injectSheet from "react-jss";

const style = ({ theme }) => ({
  labelContainer: {
    marginBottom: "8px",
    textAlign: "left",
    maxWidth: "500px"
  },
  label: {
    fontFamily: theme.fonts.sans,
    fontSize: "14px",
    color: theme.colors.black,
    marginRight: ({ tooltip }) => (tooltip ? "5px" : 0)
  },
  required: {
    display: "inline-flex",
    verticalAlign: "top",
    marginLeft: 4,
    paddingTop: 4,
    "&:after": {
      content: "''",
      display: "block",
      backgroundColor: theme.colors.tertiary2,
      width: 7,
      height: 7,
      borderRadius: 50
    }
  }
});

const Label = ({ classes, required, tooltip, htmlFor, children }) => (
  <div className={classes.labelContainer}>
    <label className={classes.label} htmlFor={htmlFor}>
      {children}
      {required && <span className={classes.required} />}
    </label>
    {tooltip ? tooltip : null}
  </div>
);

Label.propTypes = {
  required: PropTypes.bool,
  htmlFor: PropTypes.string,
  tooltip: PropTypes.element
};
export default injectSheet(style)(Label);
